import lazyWithRetry from '@shared/lib/lazyWithRetry';

import Loadable from '@components/Loadable/Loadable.tsx';
import { SuperAdminProtectedRoute } from '@providers/SuperAdminProtectedRoute/ui/SuperAdminProtectedRoute';

const DocumentTemplateCreatePage = Loadable(
  lazyWithRetry(
    () => import('@pages/SuperAdminPanelPage/DocumentTemplatePage/create.tsx')
  )
);
const DocumentTemplateUpdatePage = Loadable(
  lazyWithRetry(
    () => import('@pages/SuperAdminPanelPage/DocumentTemplatePage/update.tsx')
  )
);

const DocumentTemplateChildRoutes = {
  path: 'admin/document-templates',
  element: <SuperAdminProtectedRoute />,
  children: [
    { path: 'create', element: <DocumentTemplateCreatePage /> },
    { path: 'edit/:id', element: <DocumentTemplateUpdatePage /> },
  ],
};

export default DocumentTemplateChildRoutes;
